var COS = require('cos-js-sdk-v5')
import { Message } from 'element-ui'
var url = window.location.href
var start = url.indexOf('#/') + 2
var end = url.indexOf('/index')
var result = url.substring(start, end)
console.log(result)

// 随机生成的数字
function generateUniqueString() {
  const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
  const currentDate = new Date().toISOString().slice(0, 10).replace(/-/g, '')
  const timestamp = Date.now().toString()
  let randomString = ''
  for (let i = 0; i < 5; i++) {
    randomString += letters.charAt(Math.floor(Math.random() * letters.length))
  }
  return randomString + currentDate + timestamp
}
export function uploadFilesimg(files, progressEvent, name, config) {
  // console.log('name:', name)
  // console.log('config:===============', config)
  // const fig = config.replace('domain=', '')
  // const domain = config.domain// fig.match(/^(https?:\/\/[^\/]+)/)[1]
  const SecretId = config.secret_id// fig.match(/secret_id=([^&]+)/)[1]
  const SecretKey = config.secret_key// fig.match(/secret_key=([^&]+)/)[1]
  const bucket = config.bucket// fig.match(/bucket=([^&]+)/)[1]
  const region = config.region// fig.match(/region=([^&]+)/)[1]
  const cos = new COS({
    SecretId, // 推荐使用环境变量获取；用户的 SecretId，建议使用子账号密钥，授权遵循最小权限指引，降低使用风险。子账号密钥获取可参考https://cloud.tencent.com/document/product/598/37140
    SecretKey// 推荐使用环境变量获取；用户的 SecretKey，建议使用子账号密钥，授权遵循最小权限指引，降低使用风险。子账号密钥获取可参考https://cloud.tencent.com/document/product/598/37140
  })
  // console.log(domain)
  // console.log(SecretId)
  // console.log(SecretKey)
  // console.log(bucket)
  // console.log(region)

  const uniqueString = generateUniqueString()

  // console.log('name:', name)
  // console.log('=======================', files.name)
  let extension = ''
  if (files.name) {
    extension = files.name.substring(files.name.lastIndexOf('.') + 1)
  }
  // const size = files.size
  // if (size === 4) {
  // 获取文件名的后缀
  const fileExtension = files.name.split('.').pop().toLowerCase()
  let filePath = ''
  if (['mp4', 'mov'].includes(fileExtension)) {
    filePath = `/dj/video/${name}/newlyinmessage/${name}${uniqueString}.${extension}`
    // filePath = `/video/${name}/` + files.name
  } else if (['jpeg', 'jpg', 'png', 'gif'].includes(fileExtension)) {
    // filePath = `/img/${name}/` + files.name
    filePath = `/dj/img/${name}/newlyinmessage/${name}${uniqueString}.${extension}`
  } else if (['xlsx', 'xls'].includes(fileExtension)) {
    filePath = `/dj/excel/${name}/${name}${uniqueString}.${extension}`
  }
  // console.log('filePath:', filePath)
  // 使用 filePath 进行后续操作，例如上传文件或其他处理
  // ...
  var fileList = [files].map(file => ({
    Bucket: bucket, /* 填入您自己的存储桶，必须字段 */
    Region: region, /* 存储桶所在地域，例如 ap-beijing，必须字段 */
    Key: filePath, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
    // Key: file.name, /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
    Body: file
  }))

  return new Promise((resolve, reject) => {
    cos.uploadFiles({
      files: fileList,
      SliceSize: 1024 * 1024 * 5, /* 触发分块上传的阈值，超过5MB使用分块上传，非必须 */
      onProgress: function(progressData) {
        // console.log(JSON.stringify(progressData), '4444444--')
        const num = progressData.loaded / progressData.total * 100 | 0 // 百分比
        progressEvent(num)
      },
      onFileFinish: function(err, data, options) {
        // console.log(options.Key + '上传' + (err ? '失败' : '成功'))
        err ? Message('上传失败') : Message.success('上传成功')
      }
    }, function(err, data) {
      if (err) {
        reject(err)
      } else {
        // -------------------------------------截视频封面---------------------------------
        // data.files[0].options.Key = domain + '/' + data.files[0].options.Key
        console.log('data+++++++++++++++++++++:', data.files[0].options.Key)
        resolve(data)
      }
    })
  })
}

